<template>
  <div class="wrap_address">
    <div class="form-row" v-if="userEmail">
      <!-- && isNewUserAdmin -->
      <div style="width: 50%" class="form-row-input">
        <ejs-textbox
          floatLabelType="Always"
          v-model="userEmail"
          placeholder="Email"
          :readonly="true"
        ></ejs-textbox>
      </div>
      <div style="width: 50%" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="oldPassword"
          @validate="(v) => (this.isOldPasswordValid = v)"
        >
          <input-password ref="refPassword" v-model="oldPassword" placeholder="Existing Password" />
        </scc-input-validator>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 50%" class="form-row-input">
        <scc-input-validator
          :password="password"
          :rules="[requiredRule]"
          :usedPasswords="[passwordLogs]"
          :currentPassword="oldPassword"
          @validate="(v) => (this.isPasswordValid = v)"
        >
          <input-password ref="refPassword" v-model="password" placeholder="New Password" />
        </scc-input-validator>
        <span v-show="this.isPasswordValid" class="e-success"
          ><span class="e-icons Selection"></span> Password is strong</span
        >
      </div>
      <div style="width: 50%" class="form-row-input">
        <scc-input-validator
          :rules="[requiredRule]"
          :value="confirmPassword"
          @validate="(v) => (this.isConfirmPassword = v)"
        >
          <input-password
            ref="refPassword"
            v-model="confirmPassword"
            placeholder="Confirm Password"
            @handle-enter-key="handleSubmit()"
          />
        </scc-input-validator>
        <span v-show="showConfirmPassword" class="e-error"
          ><span class="e-icons close"></span> Confirm password does not match with Password</span
        >
        <span v-show="showConfirmPasswordMatch" class="e-success"
          ><span class="e-icons Selection"></span> Password matched</span
        >
      </div>
      <div style="width: 50%" class="form-row-input">
        <span class="e-error">
          {{ passwordValidationMessage }}
        </span>
      </div>
    </div>
    <div class="form-row" style="padding: 0px 0px 15px 0px; margin: -5px">
      <ejs-checkbox
        v-if="showForcePasswordChange"
        label="Force User to Reset Password"
        :checked="isForcePasswordChange"
        @change="onForceUsertoResetPasswordChange"
        labelPosition="Before"
      ></ejs-checkbox>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import appConfig from "@/app.config";
import SccInputValidator from "../../../components/base/scc-input-validator.vue";
import inputPassword from "../../../components/base/input-password.vue";

import {
  REGISTER, RESET_PASSWORD, CHANGE_PASSWORD, GET_PASSWORD_LOGS,
} from "../store";

Vue.use(TextBoxPlugin);

export default {
  name: "WebLoginInfo",
  components: {
    SccInputValidator,
    inputPassword,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
    enableForcePasswordChange: Boolean,
    handleSubmit: Function,
  },
  created() {
    this.getPasswordLogsByUserId();
  },
  mounted() {},
  computed: {
    userEmail() {
      if (this.userProfilesData !== null) {
        if (this.userProfilesData.isAnonymous === false) {
          return this.userProfilesData.userName;
        }
        return null;
      }
      return null;
    },
  },
  data() {
    return {
      username: null,
      email: null,
      userId: null,
      isConfirmPassword: false,
      showConfirmPassword: false,
      isPasswordValid: false,
      isOldPasswordValid: false,
      requiredRule: {
        regEx: "^(?!\\s*$).+",
        message: "This field is required",
      },
      passwordValidationMessage: appConfig.passwordValidationMessage,
      // passwordRule: {
      //   regEx: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$',
      //   message: 'Password should have at least 8 characters, one uppercase letter,
      // one lowercase letter, one number and one special character.',
      // },
      password: null,
      confirmPassword: null,
      oldPassword: null,
      showConfirmPasswordMatch: false,
      passwordLogs: [],
      // showPasswordStrong: false,
      isForcePasswordChange: this.enableForcePasswordChange ?? true,
      showForcePasswordChange: this.enableForcePasswordChange,
    };
  },
  watch: {
    confirmPassword(val) {
      if (val !== this.password && (this.password !== null || this.password !== "")) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === "") {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
        this.isConfirmPassword = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }

      this.checkSubmitButton();
    },
    password(val) {
      if (this.confirmPassword === null || this.confirmPassword === "") {
        this.showConfirmPasswordMatch = false;
      } else if (val !== "" && val !== this.confirmPassword) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === null || val === "") {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
        this.isConfirmPassword = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }

      this.checkSubmitButton();
    },
  },
  methods: {
    checkSubmitButton() {
      if (this.isPasswordValid && this.isConfirmPassword && this.showConfirmPasswordMatch) {
        console.log(55);
        this.$emit('enable-submit', true);
      } else {
        this.$emit('enable-submit', false);
      }
    },
    onForceUsertoResetPasswordChange(e) {
      this.isForcePasswordChange = e.checked;
    },
    async getPasswordLogsByUserId() {
      const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
      if (userId) {
        await this.$store.dispatch(GET_PASSWORD_LOGS, { userId });
        this.passwordLogs = this.$store.getters.passwordLogs;
      }
    },
    validatePassword() {
      this.password = this.password === null ? "" : this.password;
      this.confirmPassword = this.confirmPassword === null ? "" : this.confirmPassword;
      if (this.userEmail) this.oldPassword = this.oldPassword === null ? "" : this.oldPassword;
    },
    async register() {
      try {
        this.userId = this.userProfileId; // this.$store.getters.confirmedUser.userId;
        this.username = this.userProfilesData.userName;
        // this.$store.getters.confirmedUser.userName;
        this.email = this.userProfilesData.userName; // this.$store.getters.confirmedUser.userName;
        const { username, email, password } = this;

        await this.$store.dispatch(REGISTER, {
          username,
          email,
          password,
          forcePasswordChange: this.isForcePasswordChange,
          isSCCUser: false,
        });
      } catch (err) {
        console.error(err);
      }
    },
    async resetPassword() {
      try {
        this.userId = this.userProfileId; // this.$store.getters.confirmedUser.userId;
        const { userId, password } = this;
        await this.$store.dispatch(RESET_PASSWORD, {
          userId,
          password,
          forcePasswordChange: false,
        });
      } catch (err) {
        console.error(err);
      }
    },
    async changePassword() {
      try {
        this.username = this.userEmail;
        const { username, oldPassword, password } = this;
        await this.$store.dispatch(CHANGE_PASSWORD, {
          username,
          oldPassword,
          password,
        });
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
  },
};
</script>
<style>
.e-icons {
  /* color: #f44336; */
  font-size: 12px;
}
.close:before {
  content: "\e7fc";
}
.Selection:before {
  content: "\e935";
}
</style>
